import { render, staticRenderFns } from "./StaffMemberForm.vue?vue&type=template&id=9671a4f4"
import script from "./StaffMemberForm.vue?vue&type=script&lang=js"
export * from "./StaffMemberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports